export const SYSTEM_ACTION = "SYSTEM_ACTION"
export const LANGUAGE_ACTION = "LANGUAGE_ACTION"


export const systemAction = (systemSettingList) => {
  return {
    type: SYSTEM_ACTION,
    payload: systemSettingList
  };
};

export const languageAction = (languageSettingList) => {
  return {
    type: LANGUAGE_ACTION,
    payload: languageSettingList
  };
};